import { YieldType } from "../../../service/globalTypes";

interface GetYieldsToResend {
  validBidStatusCode: boolean;
  validAskStatusCode: boolean;
  bid: string;
  ask: string;
  commonSecurityInfo: { isin: string; quoteFeedID: string };
  currentErrorSentYields: YieldType[];
}

export const getYieldsToResend = ({
  validBidStatusCode,
  validAskStatusCode,
  bid,
  ask,
  commonSecurityInfo,
  currentErrorSentYields,
}: GetYieldsToResend) => {
  const yieldsToResend = [];

  if (validBidStatusCode && !currentErrorSentYields.includes(YieldType.BID) && bid) {
    yieldsToResend.push({ ...commonSecurityInfo, yieldType: YieldType.BID, yieldValue: bid });
  }

  if (validAskStatusCode && !currentErrorSentYields.includes(YieldType.ASK) && ask) {
    yieldsToResend.push({ ...commonSecurityInfo, yieldType: YieldType.ASK, yieldValue: ask });
  }

  return yieldsToResend;
};
